import { Sound, SoundNoDates } from "@/types/types";

export const parseDatesSound = (sound: SoundNoDates): Sound => {
  const { createdAtString, ...newSound } = sound;

  const newNewSound = {
    ...newSound,
    createdAt: new Date(createdAtString),
  };

  return newNewSound;
};
